<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col 
        v-for="(insp) in inspecteurs"
        :key="insp.id" 
        cols="4"
      >
        <operationeel-status 
          :user="insp" 
          @toon-details="(args) => getDetails({...args,jaar:jaar})"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-table 
        :items="details"
        :fields="['#','Status','data.toegewezen_aan.Naam','Omschrijving',{key:'DatumKolom',label: 'Datum' }]"
        :busy="busy"
        dark 
        small
        bordered
        primary-key="data.id"
      >
        <template #table-busy>
          <div class="text-center text-white my-2">
            <b-spinner class="align-middle mx-2" />
            <strong>Laden...</strong>
          </div>
        </template>
        <template #cell(#)="row">
          {{ row.index+1 }}
        </template>
        <template #cell(Status)="row">
          <font-awesome-icon 
            v-if="row.item.data.status === 'OPEN'" 
            icon="square"
          />
          <font-awesome-icon 
            v-if="row.item.data.status === 'AUDIT'" 
            icon="check"
          />
          {{ row.item.data.status }}
        </template>

        <template 
          #cell(DatumKolom)="row" 
        >
          <span v-if="row.item.data.datum == null">
            {{ moment(row.item.data.deadline).fromNow() }}
          </span>
          <span v-else>
            {{ moment(row.item.data.datum).format('L') }}
          </span>
        </template>
           
        <template #cell(Omschrijving)="row">
          {{ row.item.titel }}<br>
          <small> {{ row.item.data.omschrijving }}</small>
        </template>
      </b-table>
    </b-row>
  </div>
</template>

<script>

import { serviceMixin } from "@/mixins/serviceMixin";
import OperationeelStatus from '../components/trajecten/OperationeelStatus.vue';

export default {
  name: 'Dashboard',
  components: {
    OperationeelStatus
  },
  mixins: [serviceMixin],
  data: function () {
    return {
      operationeel: [],
      details: [],
      selected: 'Month',
      busy: false,
      jaar: new Date().getFullYear()
    }
  },
  computed: {
    operationeelJaar: function() { return this.operationeel.filter((i) => i.jaar == this.jaar) },
    inspecteurs: function() {
      var insp = {};
      this.operationeelJaar.forEach(function(n) {
        if (!insp[n.id]) insp[n.id] = {
          'naam': n.naam,
          'id': n.id,
          'Q1': {'OPEN':0,'AUDIT': 0,'CLOSED': 0},
          'Q2': {'OPEN':0,'AUDIT': 0,'CLOSED': 0},
          'Q3': {'OPEN':0,'AUDIT': 0,'CLOSED': 0},
          'Q4': {'OPEN':0,'AUDIT': 0,'CLOSED': 0},
        }
        insp[n.id][`Q${n.kwartaal}`][n.status] = n.aantal
      })
      return insp;
    }
  },
  mounted() {
    this.getOperationeel();
  },
  methods: {
    getDetails(params) {
     var vm = this;
     this.busy = true;
     console.log(params)
      this.post('/dashboard/operationeel/details',params)
      .then(function(resp) { 
        vm.$set(vm,'details',resp.data.events); 
        console.log(resp.data) })
      .catch(function(error) { console.log(error) })
      .finally(() => vm.busy = false);
    },
    getOperationeel() {
      var vm = this;
      this.get('/dashboard/operationeel')
      .then(function(resp) { vm.$set(vm,'operationeel',resp.data.operationeel); console.log(resp.data) })
      .catch(function(error) { console.log(error) });
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    }
  }
}
</script>